import * as yup from 'yup';

export const DEFAULT_PHONE = '+18883561435';

const US_PHONE_REGEX = /^(?:1)?[2-9]\d{2}[2-9]\d{6}$/;

export const usPhoneSchema = yup
  .string()
  .required('Phone is required')
  .test(
    'us-phone-regex',
    'Enter a valid 10-digit phone number',
    (value) => !value || US_PHONE_REGEX.test(value.replace(/\D/g, ''))
  );

export type PhoneConfig = {
  lock_exp?: string;
  message?: string;
  phone?: string;
  status?: boolean;
};
